export const columns = [
  {
    accessorKey: "status",
    header: "Status",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "colorCode",
    header: "Color",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isOutOfWarehouse",
    header: "Out of warehouse",
    type: "boolean",
    size: 200,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
